<template lang='pug'>
div
    UHFSensorSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title UHF-LS-50
            h2.product-subtitle Standpipe Partial Discharge Sensor for Installation at Distribution-level Transformers

        div.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50.webp')
                        img( src='@/assets/photos/UHF-LS-50.png', width="100%", alt='UHF PD Sensor UHF-LS-50', title='UHF PD Sensor UHF-LS-50')
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li For oil-filled distribution transformers
                            li Bandwidth: 100 MHz ... 3 GHz
                            li Mounting on typical standpipes for level switches
                            li Integrated high-pass filter
                    .bluebox
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet UHF-LS-50.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-LS-50', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/pdm-600-mobile", text='PDM-600-Mobile')
                    
        div.margin-bottom
            p The Sensor is used for the decoupling of electromagnetic PD signals from the inside of distribution- and windmill-transformers. The sensor is designed for retrofit of transformers with standpipes. Different sensor lengths and screw threads are available. The sensor can be used at transformers with or without gas headspace.

        div.margin-bottom
            .column-container
                .column
                    p UHF PD-Sensor UHF-LS-50 installed in a standpipe:
                .column.center-content
                    picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50_in_pipe.webp')
                        img( src='@/assets/photos/UHF-LS-50_in_pipe.jpg', width="300px", alt='UHF PD-Sensor UHF-LS-50 installed in a standpipe', title='UHF PD-Sensor UHF-LS-50 installed in a standpipe')


    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title UHF-LS-50
            h2.product-subtitle Standrohr-Teilentladungs-Sensor für die Installation an Verteiltransformatoren

        div.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50.webp')
                        img( src='@/assets/photos/UHF-LS-50.png', width="100%", alt='UHF-TE-Sensor UHF-LS-50', title='UHF-TE-Sensor UHF-LS-50')
                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Für ölgefüllte Verteiltransformatoren
                            li Bandwidth: 100 MHz ... 3 GHz
                            li Montage an typischen Standrohren für Levelschalter
                            li Integrierter Hochpassfilter
                    .bluebox
                        Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet UHF-LS-50.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-LS-50', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                        Sitelink(to="/de/products/pdm-600-mobile", text='PDM-600-Mobile')
                    
        div.margin-bottom
            p Der Sensor wird verwendet, um elektromagnetische TE-Impulse aus dem Inneren von Verteil- und Windkraftanlagentransformatoren auszukoppeln. Der Sensor ist für die nachträgliche Installation an Standrohren mit Innengewinde entwickelt. Verschiedene Gewindearten und Sensorlängen sind verfügbar. Der Sensor kann bei Transformatoren mit und ohne Gasvorlage eingesetzt werden.

        div.margin-bottom
            .column-container
                .column
                    p UHF-TE-Sensor UHF-LS-50 installiert in einem Standrohr:
                .column.center-content
                    picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-LS-50_in_pipe.webp')
                        img( src='@/assets/photos/UHF-LS-50_in_pipe.jpg', width="300px", alt='UHF-TE-Sensor UHF-LS-50 installiert in einem Standrohr', title='UHF-TE-Sensor UHF-LS-50 installiert in einem Standrohr')

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | UHF-LS-50",
            description:
                "Standrohr-Teilentladungs-Sensor für die Installation an Verteiltransformatoren",
        },
        en: {
            title: "BSS | UHF-LS-50",
            description:
                "Standpipe Partial Discharge Sensor for Installation at Distribution-level Transformers",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>